import * as React from "react";
function isDialogHistoryEntryOnTop() {
    var _a;
    const state = window.history.state;
    return typeof state === "object" && state !== null && ((_a = Object.getOwnPropertyDescriptor(state, "dialogBackButton")) === null || _a === void 0 ? void 0 : _a.value) === true;
}
export function useDialogBackButton(open, onClose) {
    const [generation, setGeneration] = React.useState(0);
    const stateRef = React.useRef({ pushed: false, popped: false, cleanupTimer: null });
    const onCloseRef = React.useRef(onClose);
    onCloseRef.current = onClose;
    React.useEffect(() => {
        if (!open)
            return undefined;
        if (stateRef.current.cleanupTimer !== null) {
            window.clearTimeout(stateRef.current.cleanupTimer);
            stateRef.current = { pushed: true, popped: false, cleanupTimer: null };
        }
        else if (!stateRef.current.pushed || stateRef.current.popped) {
            stateRef.current = { pushed: true, popped: false, cleanupTimer: null };
            window.history.pushState({ ...window.history.state, dialogBackButton: true }, "");
        }
        const handlePopState = () => {
            if (!stateRef.current.pushed || stateRef.current.popped)
                return;
            stateRef.current.popped = true;
            onCloseRef.current();
            setGeneration((g) => g + 1);
        };
        window.addEventListener("popstate", handlePopState, { once: true });
        return () => {
            window.removeEventListener("popstate", handlePopState);
            if (stateRef.current.pushed && !stateRef.current.popped) {
                stateRef.current.popped = true;
                stateRef.current.cleanupTimer = window.setTimeout(() => {
                    stateRef.current.cleanupTimer = null;
                    if (isDialogHistoryEntryOnTop()) {
                        window.history.back();
                    }
                }, 0);
            }
        };
    }, [open, generation]);
}
